export const unique = <T>(array: T[], key: string): T[] => {
  const out: T[] = [];
  array.forEach(item => {
    if (out.find(i => i[key] === item[key])) {
      return;
    }
    out.push(item);
  });
  return out;
};
